import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as CoreActions from '@app/core/store/core.action';
import { selectCoreState, selectIsNavOpen, showErrorMessage } from '@app/core/store/core.selectors';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs';

@Component({
  selector: 'app-permission-modal',
  templateUrl: './permission-modal.component.html',
  styleUrls: ['./permission-modal.component.scss']
})
export class PermissionModalComponent implements OnInit {

  public title: string;
  public body: string;
  
  constructor(
    private store$: Store,
    private _translation: TranslateService,
    private _matDialog: MatDialog,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data,
  ) { }

  
  ngOnInit(): void {
    // this.store$.select(showErrorMessage).subscribe(errorMessage => {
    //   this.title = errorMessage?.title ?? '';
    //   this.body = errorMessage?.body ?? '';
    //   this.show_upgrade = errorMessage?.show_upgrade ?? '';
    // });

    this.title = this.data?.title ?? '';
    this.body = this.data?.body ?? '';
  }

  public goToHome() {
    window.location.href = '/';
  }


}
